import FilterController from '../Controller'

export default {
  props: [
    'value',
    'allProps',
    'additionalProps',
    'pagination',
    'label',
    'additionalResource',
    'totalItems',
    'filters',
  ],

  components: {
    FilterController,
  },

  data() {
    return {
      allFilters: this.value.filters,
    }
  },
  methods: {
    handleFilter(parameters) {
      this.$emit('input', parameters)
    },
  },
}
